import moment from 'moment';
import Head from 'next/head';
import { useEffect, useState } from 'react';
import { useRecoilState } from 'recoil';

import { user } from '../../atoms/user';
import RewardsCard, {
  CardData,
} from '../../components/ReferPageComp/Mission/RewardsCard';
import { pageTitle } from '../../components/shared/basic/customHead';
import { ShouldRender } from '../../components/shared/basic/ShouldRender';
import { formateErrorObject } from '../../components/shared/formateErrorObject';
import CustomLoader from '../../components/shared/Loading';
import { notify } from '../../components/shared/notify';
import { claimRewardDynamic, getAllRewards } from '../../services/reward';
import { User } from '../../utils/interfaces/User';

const RewardStore = () => {
  const [loadingRewards, setLoadingRewards] = useState<boolean>(true);
  const [data, setData] = useState<CardData[]>([]);
  const [selectedValue, setSelectedValue] = useState<string>('last30Days');
  const [dates, setDates] = useState<{ start_date: string; end_date: string }>({
    start_date: moment().subtract(30, 'days').format('YYYY-MM-DD'),
    end_date: moment().format('YYYY-MM-DD'),
  });

  const [userData, setUserData] = useRecoilState<User | undefined>(user);
  const [loading, setLoading] = useState<{ value: boolean; id: string | null }>(
    {
      id: null,
      value: false,
    },
  );

  const handleGetAllUserRewards = async () => {
    setLoadingRewards(true);
    try {
      const response = await getAllRewards(
        selectedValue === 'customRange' ? {} : { ...dates },
      );
      const { data: rewards } = response;

      setData(
        rewards?.map((item: any) => ({
          id: item.id,
          title: item.title,
          coins: item.reward_amount,
          description: item.description,
          buttonText: item.ui,
          claimable: item.claimable,
          createdAt: item.created_at,
          isUsed: item?.used || false,
          isExpired: item?.expired || false,
        })),
      );
    } catch (error: any) {
      notify(formateErrorObject(error), 'error');
    } finally {
      setLoadingRewards(false);
    }
  };
  const handleClaimRewardDynamic = async (id: string) => {
    setLoading({
      id: id,
      value: true,
    });
    try {
      const data = await claimRewardDynamic(id);
      setUserData((prevUserData) => {
        if (!prevUserData) return undefined;
        return {
          ...prevUserData,
          balance: (userData?.balance || 0) + data.data.reward_amount,
        };
      });
      setData((prevData) =>
        prevData?.map((card: CardData) =>
          card.id === Number(id) ? { ...card, isUsed: true } : card,
        ),
      );
      notify('Reward Claimed successfully ! ', 'success');
    } catch (error: any) {
      notify(formateErrorObject(error), 'error');
    } finally {
      setLoading({
        id: id,
        value: false,
      });
    }
  };
  useEffect(() => {
    handleGetAllUserRewards();
  }, [selectedValue]);

  return (
    <div>
      <Head>
        <title>{pageTitle('Reward-Store')}</title>
      </Head>
      <div className=' flex flex-col'>
        <div className='p-5 pt-6'>
          <ShouldRender check={!loadingRewards}>
            <RewardsCard
              data={data}
              selectedValue={selectedValue}
              setDates={setDates}
              setSelectedValue={setSelectedValue}
              handleClaimRewardDynamic={handleClaimRewardDynamic}
              loading={loading}
            />{' '}
          </ShouldRender>
          <ShouldRender check={loadingRewards}>
            <CustomLoader />
          </ShouldRender>
        </div>
      </div>
    </div>
  );
};

export default RewardStore;
